import axios from 'axios';
import _ from 'lodash';
import { useStorage } from '../hooks/use-storage';

function useSuggestionAPI() {
  const { menuIdRef, userRef, languageRef } = useStorage();

  function findSuggestionsFromRemote({ session }) {
    const url = `/vbeta2/suggestions`;
    const params = {};

    if (!_.isEmpty(session?.id)) {
      params.session_id = session?.id;
      params.lang = languageRef.current?.tag;
    }

    const headers = {
      'Menu-Id': menuIdRef.current,
      'Accept-Language': languageRef.current?.tag,
    };

    if (userRef?.current != null) {
      headers.Authorization = `Bearer ${userRef?.current?.token}`;
    }

    return axios({
      url,
      params,
      method: 'get',
      headers,
      responseType: 'json',
    });
  }

  return {
    findSuggestionsFromRemote,
  };
}

export { useSuggestionAPI };
